/*
 * Copyright (c) 2022-2024. Haodong JU
 */

import Vue from 'vue'
import Vuetify, { colors } from 'vuetify/lib'
import i18n from '@/i18n'
import '@/scss/overrides.sass'
import Fragment from 'vue-fragment'
import '@mdi/font/css/materialdesignicons.css'
import '@fontsource/roboto-flex'
import '@fontsource/roboto-flex/400.css'
// import '@fontsource/roboto-flex/400-italic.css'
import '@fontsource/noto-sans'
import '@fontsource/noto-sans/400.css'
import '@fontsource/noto-sans/400-italic.css'
import dayjs from 'dayjs'
import { getNiceLabel } from '@/model/utils/DateRepository'
import { formatPrice } from '@/model/utils/formatPrice'
import { abbreviateNumber } from 'js-abbreviation-number'
import store from '@/model/global/store'
// theme Main scss
Vue.use(Vuetify)
Vue.use(Fragment.Plugin)
Vue.filter('timeStampDisplay', function (timeStamp) {
  return timeStamp?.split(' ')[1]
})
Vue.filter('beautifulTime', function (timeStamp) {
  return dayjs(timeStamp, 'YYYY-MM-DD HH:mm:ss').format('DD.MM/HH:mm')
})

Vue.filter('beautifulTimeByStampTime', function (timeStamp) {
  return dayjs.unix(timeStamp).format('DD.MM.YYYY/HH:mm')
})

Vue.filter('timeToNow', function (time) {
  return dayjs(time).fromNow()
})
Vue.filter('niceLabel', arr => {
  return getNiceLabel(arr)
})
Vue.filter('priceDisplay', function (price) {
  return formatPrice(price)
})

Vue.filter('percent', function (price) {
  return (parseFloat(price) * 100).toFixed(0) + '%'
})

Vue.filter('reportPriceDisplay', function (price) {
  const res = parseFloat(price).toFixed(2) === '-0.00' ? '0.00' : abbreviateNumber(parseFloat(price).toFixed(2), 1)
  if (store.state.currency === '9527') {
    return '$ ' + res.replace(',', '.')
  } else {
    return res
  }
})

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  },
  theme: {
    // dark: mq.matches,
    dark: false,

    default: 'light',
    disable: false,
    options: {
      cspNonce: undefined,
      customProperties: true,
      minifyTheme: undefined,
      themeCache: undefined
    },
    themes: {
      light: {
        primary: '#000',
        secondary: colors.green.darken2,
        success: colors.green,
        danger: colors.red,
        warning: colors.deepOrange,
        info: colors.indigo,
        dark: '#242939',
        background: '#fafbfc'
      },
      dark: {
        primary: colors.blue,
        secondary: '#304156',
        success: colors.green,
        danger: colors.red,
        warning: colors.deepOrange,
        info: colors.indigo
      }
    }
  }
})
